import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import Login from '../auth/Login';
import Alert from '../layout/Alert';
import Dashboard from '../dashboard/Dashboard';
import NotFound from '../layout/NotFound';
import AddVendingMachine from '../vendingMachine/AddVendingMachine';
import VendingMachineDetails from '../vendingMachine/VendingMachineDetails';
import Inventory from '../vendingMachine/Inventory';
import Product from '../Product/Product';
import Products from '../Product/Products';
import Orders from '../Order/Orders';
import Order from '../Order/Order';
import Users from '../User/Users';
import User from '../User/User';
import Profile from '../Profile/Profile';
import Profiles from '../Profile/Profiles';
import Regions from '../Region/Regions';
import Region from '../Region/Region';
import Transactions from '../CanTransactions/Transactions';
import Transaction from '../CanTransactions/Transaction';
import Downloads from '../Downloads/Downloads';
import InventoryStatus from '../Inventory/Status';
import CanStock from '../Can/CanStock';
import CanManagement from '../Can/CanManagement';
import PrivateRoute from './PrivateRoute';
import Ledger from '../Ledger/Ledger';
import RegisterVM from '../RegisterVM/Register';
import ListRegisteredVM from '../RegisterVM/List';
import RegistrationDetails from '../RegisterVM/RegistrationDetails';
import TransactionLedgers from '../TransactionLedger/Ledger';
import Sales from '../Sales/Sales';
import AccountDeletion from '../DeleteAccount/Deletion';
import ProductPackages from '../ProductPackage/Packages';
import ProductPackage from '../ProductPackage/Package';
import Memberships from '../Membership/Memberships';
import Membership from '../Membership/Membership';
import DepositLedger from '../DepositLedger/DepositLedger';
import Accessories from '../Accessory/Accessories';
import Accessory from '../Accessory/Accessory';
import AccessoryPurchases from '../AccessoryPurchase/AccessoryPurchases';
import AccessoryPurchase from '../AccessoryPurchase/AccessoryPurchase';
import UnserviceableAreaRequests from '../UnserviceableAreaRequest/UnserviceableAreaRequests';
import UnserviceableAreaRequest from '../UnserviceableAreaRequest/UnserviceableAreaRequest';
import GetStarteds from '../GetStarted/GetStarteds';
import GetStarted from '../GetStarted/GetStarted';
import ReferralContents from '../ReferralContent/ReferralContents';
import ReferralContent from '../ReferralContent/ReferralContent';
import AssignDeliveryAgent from '../Delivery/AssignDeliveryAgent';
import DeliveryProfiles from '../DeliveryProfile/DeliveryProfiles';
import DeliveryProfile from '../DeliveryProfile/DeliveryProfile';
import DeliveryCanTransactions from '../CanTransactions/DeliveryCanTransactions';
import DeliveryCanTransaction from '../CanTransactions/DeliveryCanTransaction';
import Agents from '../Agent/Agents';
import AgentOnboarding from '../Agent/AgentOnboarding';
import ServiceableAreas from '../ServiceableArea/ServiceableAreas';
import ServiceableArea from '../ServiceableArea/ServiceableArea';
import SuperServiceableAreas from '../SuperServiceableArea/SuperServiceableAreas';
import SuperServiceableArea from '../SuperServiceableArea/SuperServiceableArea';
import Sectors from '../Sector/Sectors';
import Sector from '../Sector/Sector';
import InventoryNodes from '../InventoryNode/InventoryNodes';
import InventoryNode from '../InventoryNode/InventoryNode';
import AgentSectorAssignments from '../AgentAssignment/AgentSectorAssignments';
import AgentSectorAssignment from '../AgentAssignment/AgentSectorAssignment';
import Notifications from '../Notification/Notifications';
import Notification from '../Notification/Notification';
import FAQs from '../FAQ/FAQs';
import FAQ from '../FAQ/FAQ';
import FAQForm from '../FAQ/FAQForm';
import WaterQuality from '../WaterQuality/WaterQuality';
import ReferralLedgers from '../ReferralLedger/ReferralLedgers';
import ReferralLedger from '../ReferralLedger/ReferralLedger';
import ReferralStats from '../ReferralLedger/ReferralStats';
import UserActivityReport from '../UserActivityReports/UserActivityReport';
import UserAnalyticsReport from '../UserActivityReports/UserAnalyticsReport';
import UserSummaryReport from '../UserActivityReports/UserSummaryReport';
import Refunds from '../Refund/Refunds';
import Refund from '../Refund/Refund';
import PaymentRefunds from '../Refund/PaymentRefunds';
import PaymentLink from '../PaymentLink/PaymentLink';
import PaymentLinksList from '../PaymentLink/PaymentLinksList';
import PaymentLinkDetail from '../PaymentLink/PaymentLinkDetail';
import KMLExtractor from '../KMLExtractor/KMLExtractor';
import CanReturns from '../CanReturn/CanReturns';
import WhatsAppOffers from '../WhatsAppAnalytics/Offers';
import WhatsAppSupportQueue from '../WhatsAppAnalytics/SupportQueue';
import WhatsAppOverview from '../WhatsAppAnalytics/Overview';
import WhatsAppJourneyFunnels from '../WhatsAppAnalytics/JourneyFunnels';
import WhatsAppMessageLog from '../WhatsAppAnalytics/MessageLog';
import WhatsAppUserTimeline from '../WhatsAppAnalytics/UserTimeline';
import WhatsAppTestFlows from '../WhatsAppAnalytics/TestFlows';
import WhatsAppStaffAlerts from '../WhatsAppAnalytics/StaffAlerts';


const AllRoutes = () => {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path='/inventory/v1.2/login' element={<Login />} />
      
      {/* Protected Routes */}
      <Route path='/inventory/v1.2/' element={
        <PrivateRoute>
          <Dashboard />
        </PrivateRoute>
      } />
      
      <Route path='/inventory/v1.2/AddVendingMachine' element={
        <PrivateRoute>
          <AddVendingMachine />
        </PrivateRoute>
      } />
      
      <Route path='/inventory/v1.2/vendingMachine/:id' element={
        <PrivateRoute>
          <VendingMachineDetails />
        </PrivateRoute>
      } />
      
      <Route path='/inventory/v1.2/vendingMachine/:id/Inventory' element={
        <PrivateRoute>
          <Inventory />
        </PrivateRoute>
      } />
      
      <Route path='/inventory/v1.2/products' element={
        <PrivateRoute>
          <Products />
        </PrivateRoute>
      } />
      
      <Route path='/inventory/v1.2/products/:id' element={
        <PrivateRoute>
          <Product />
        </PrivateRoute>
      } />
      
      <Route path='/inventory/v1.2/profiles' element={
        <PrivateRoute>
          <Profiles />
        </PrivateRoute>
      } />
      
      <Route path='/inventory/v1.2/profiles/:id' element={
        <PrivateRoute>
          <Profile />
        </PrivateRoute>
      } />
      
      <Route path='/inventory/v1.2/orders' element={
        <PrivateRoute>
          <Orders />
        </PrivateRoute>
      } />
      
      <Route path='/inventory/v1.2/orders/:id' element={
        <PrivateRoute>
          <Order />
        </PrivateRoute>
      } />
      
      <Route path='/inventory/v1.2/transactions' element={
        <PrivateRoute>
          <Transactions />
        </PrivateRoute>
      } />
      
      <Route path='/inventory/v1.2/transactions/:id' element={
        <PrivateRoute>
          <Transaction />
        </PrivateRoute>
      } />
      
      <Route path='/inventory/v1.2/users' element={
        <PrivateRoute>
          <Users />
        </PrivateRoute>
      } />
      
      <Route path='/inventory/v1.2/users/:id' element={
        <PrivateRoute>
          <User />
        </PrivateRoute>
      } />
      
      <Route path='/inventory/v1.2/regions' element={
        <PrivateRoute>
          <Regions />
        </PrivateRoute>
      } />
      
      <Route path='/inventory/v1.2/regions/:id' element={
        <PrivateRoute>
          <Region />
        </PrivateRoute>
      } />
      
      <Route path='/inventory/v1.2/downloads' element={
        <PrivateRoute>
          <Downloads />
        </PrivateRoute>
      } />
      
      <Route path='/inventory/v1.2/inventory-status' element={
        <PrivateRoute>
          <InventoryStatus />
        </PrivateRoute>
      } />
      
      <Route path='/inventory/v1.2/cans-in-stock' element={
        <PrivateRoute>
          <CanStock />
        </PrivateRoute>
      } />
      
      <Route path='/inventory/v1.2/cans/manage' element={
        <PrivateRoute>
          <CanManagement />
        </PrivateRoute>
      } />

      <Route path='/inventory/v1.2/ledger' element={
        <PrivateRoute>
          <Ledger />
        </PrivateRoute>
      } />
      
      <Route path='/inventory/v1.2/deposit-ledger' element={
        <PrivateRoute>
          <DepositLedger />
        </PrivateRoute>
      } />
      
      <Route path='/inventory/v1.2/register-vending-machine' element={
        <PrivateRoute>
          <RegisterVM />
        </PrivateRoute>
      } />
      
      <Route path='/inventory/v1.2/list-registered-vending-machine' element={
        <PrivateRoute>
          <ListRegisteredVM />
        </PrivateRoute>
      } />
      
      <Route path='/inventory/v1.2/list-registered-vending-machine/:id' element={
        <PrivateRoute>
          <RegistrationDetails />
        </PrivateRoute>
      } />
      
      <Route path='/inventory/v1.2/transaction-ledger' element={
        <PrivateRoute>
          <TransactionLedgers />
        </PrivateRoute>
      } />
      
      <Route path='/inventory/v1.2/sales' element={
        <PrivateRoute>
          <Sales />
        </PrivateRoute>
      } />
      
      <Route path='/inventory/v1.2/account-deletion' element={
        <PrivateRoute>
          <AccountDeletion />
        </PrivateRoute>
      } />
      
      <Route path='/inventory/v1.2/product-package' element={
        <PrivateRoute>
          <ProductPackages />
        </PrivateRoute>
      } />
      
      <Route path='/inventory/v1.2/product-package/:id' element={
        <PrivateRoute>
          <ProductPackage />
        </PrivateRoute>
      } />

      <Route path='/inventory/v1.2/memberships' element={
        <PrivateRoute>
          <Memberships />
        </PrivateRoute>
      } />

      <Route path='/inventory/v1.2/memberships/:id' element={
        <PrivateRoute>
          <Membership />
        </PrivateRoute>
      } />

      <Route path='/inventory/v1.2/delivery-profiles' element={
        <PrivateRoute>
          <DeliveryProfiles />
        </PrivateRoute>
      } />

      <Route path='/inventory/v1.2/delivery-profiles/:id' element={
        <PrivateRoute>
          <DeliveryProfile />
        </PrivateRoute>
      } />

      <Route path='/inventory/v1.2/accessories' element={
        <PrivateRoute>
          <Accessories />
        </PrivateRoute>
      } />

      <Route path='/inventory/v1.2/accessories/:id' element={
        <PrivateRoute>
          <Accessory />
        </PrivateRoute>
      } />

      <Route path='/inventory/v1.2/accessory-purchases' element={
        <PrivateRoute>
          <AccessoryPurchases />
        </PrivateRoute>
      } />

      <Route path='/inventory/v1.2/accessory-purchases/:id' element={
        <PrivateRoute>
          <AccessoryPurchase />
        </PrivateRoute>
      } />

      <Route path='/inventory/v1.2/unserviceable-area-requests' element={
        <PrivateRoute>
          <UnserviceableAreaRequests />
        </PrivateRoute>
      } />

      <Route path='/inventory/v1.2/unserviceable-area-requests/:id' element={
        <PrivateRoute>
          <UnserviceableAreaRequest />
        </PrivateRoute>
      } />

      <Route path='/inventory/v1.2/getstarted' element={
        <PrivateRoute>
          <GetStarteds />
        </PrivateRoute>
      } />
      <Route path='/inventory/v1.2/getstarted/:id' element={
        <PrivateRoute>
          <GetStarted />
        </PrivateRoute>
      } />

      <Route path='/inventory/v1.2/referral-contents' element={
        <PrivateRoute>
          <ReferralContents />
        </PrivateRoute>
      } />

      <Route path='/inventory/v1.2/referral-contents/:id' element={
        <PrivateRoute>
          <ReferralContent />
        </PrivateRoute>
      } />

      <Route path='/inventory/v1.2/delivery-management' element={
        <PrivateRoute>
          <AssignDeliveryAgent />
        </PrivateRoute>
      } />

      <Route path='/inventory/v1.2/delivery-transactions' element={
        <PrivateRoute>
          <DeliveryCanTransactions />
        </PrivateRoute>
      } />

      <Route path='/inventory/v1.2/delivery-transactions/:id' element={
        <PrivateRoute>
          <DeliveryCanTransaction />
        </PrivateRoute>
      } />

      <Route path='/inventory/v1.2/can-returns' element={
        <PrivateRoute>
          <CanReturns />
        </PrivateRoute>
      } />

      <Route path='/inventory/v1.2/agents' element={
        <PrivateRoute>
          <Agents />
        </PrivateRoute>
      } />

      <Route path='/inventory/v1.2/agents/:id' element={
        <PrivateRoute>
          <AgentOnboarding />
        </PrivateRoute>
      } />

      <Route path='/inventory/v1.2/serviceable-areas' element={
        <PrivateRoute>
          <ServiceableAreas />
        </PrivateRoute>
      } />

      <Route path='/inventory/v1.2/serviceable-areas/:id' element={
        <PrivateRoute>
          <ServiceableArea />
        </PrivateRoute>
      } />

      <Route path='/inventory/v1.2/super-serviceable-areas' element={
        <PrivateRoute>
          <SuperServiceableAreas />
        </PrivateRoute>
      } />

      <Route path='/inventory/v1.2/super-serviceable-areas/:id' element={
        <PrivateRoute>
          <SuperServiceableArea />
        </PrivateRoute>
      } />

      <Route path='/inventory/v1.2/sectors' element={
        <PrivateRoute>
          <Sectors />
        </PrivateRoute>
      } />

      <Route path='/inventory/v1.2/sectors/:id' element={
        <PrivateRoute>
          <Sector />
        </PrivateRoute>
      } />

      <Route path='/inventory/v1.2/inventory-nodes' element={
        <PrivateRoute>
          <InventoryNodes />
        </PrivateRoute>
      } />

      <Route path='/inventory/v1.2/inventory-nodes/:id' element={
        <PrivateRoute>
          <InventoryNode />
        </PrivateRoute>
      } />

      <Route path='/inventory/v1.2/agent-sector-assignments' element={
        <PrivateRoute>
          <AgentSectorAssignments />
        </PrivateRoute>
      } />

      <Route path='/inventory/v1.2/agent-sector-assignments/:id' element={
        <PrivateRoute>
          <AgentSectorAssignment />
        </PrivateRoute>
      } />

      <Route path='/inventory/v1.2/notifications' element={
        <PrivateRoute>
          <Notifications />
        </PrivateRoute>
      } />

      <Route path='/inventory/v1.2/notifications/:id' element={
        <PrivateRoute>
          <Notification />
        </PrivateRoute>
      } />

      <Route path='/inventory/v1.2/faqs' element={
        <PrivateRoute>
          <FAQs />
        </PrivateRoute>
      } />

      <Route path='/inventory/v1.2/faqs/new' element={
        <PrivateRoute>
          <FAQForm />
        </PrivateRoute>
      } />

      <Route path='/inventory/v1.2/faqs/:id' element={
        <PrivateRoute>
          <FAQ />
        </PrivateRoute>
      } />

      <Route path='/inventory/v1.2/faqs/:id/edit' element={
        <PrivateRoute>
          <FAQForm />
        </PrivateRoute>
      } />

      <Route path='/inventory/v1.2/kml-extractor' element={
        <PrivateRoute>
          <KMLExtractor />
        </PrivateRoute>
      } />

      <Route path='/inventory/v1.2/water-quality/new' element={
        <PrivateRoute>
          <WaterQuality />
        </PrivateRoute>
      } />

      <Route path='/inventory/v1.2/water-quality/:id' element={
        <PrivateRoute>
          <WaterQuality />
        </PrivateRoute>
      } />

      <Route path='/inventory/v1.2/water-quality' element={
        <PrivateRoute>
          <WaterQuality />
        </PrivateRoute>
      } />

      <Route path='/inventory/v1.2/referral-ledger' element={
        <PrivateRoute>
          <ReferralLedgers />
        </PrivateRoute>
      } />

      <Route path='/inventory/v1.2/referral-ledger/:id' element={
        <PrivateRoute>
          <ReferralLedger />
        </PrivateRoute>
      } />

      <Route path='/inventory/v1.2/referral-stats' element={
        <PrivateRoute>
          <ReferralStats />
        </PrivateRoute>
      } />

      <Route path='/inventory/v1.2/user-activity-report' element={
        <PrivateRoute>
          <UserActivityReport />
        </PrivateRoute>
      } />

      <Route path='/inventory/v1.2/user-analytics-report' element={
        <PrivateRoute>
          <UserAnalyticsReport />
        </PrivateRoute>
      } />

      <Route path='/inventory/v1.2/user-summary-report' element={
        <PrivateRoute>
          <UserSummaryReport />
        </PrivateRoute>
      } />

      <Route path='/inventory/v1.2/refunds' element={
        <PrivateRoute>
          <Refunds />
        </PrivateRoute>
      } />

      <Route path='/inventory/v1.2/refunds/:id' element={
        <PrivateRoute>
          <Refund />
        </PrivateRoute>
      } />

      <Route path='/inventory/v1.2/payments/:paymentId/refunds' element={
        <PrivateRoute>
          <PaymentRefunds />
        </PrivateRoute>
      } />

      <Route path='/inventory/v1.2/payment-link' element={
        <PrivateRoute>
          <PaymentLink />
        </PrivateRoute>
      } />

      <Route path='/inventory/v1.2/payment-links' element={
        <PrivateRoute>
          <PaymentLinksList />
        </PrivateRoute>
      } />

      <Route path='/inventory/v1.2/payment-links/:id' element={
        <PrivateRoute>
          <PaymentLinkDetail />
        </PrivateRoute>
      } />

      <Route path='/inventory/v1.2/whatsapp/overview' element={
        <PrivateRoute>
          <WhatsAppOverview />
        </PrivateRoute>
      } />

      <Route path='/inventory/v1.2/whatsapp/journeys' element={
        <PrivateRoute>
          <WhatsAppJourneyFunnels />
        </PrivateRoute>
      } />

      <Route path='/inventory/v1.2/whatsapp/messages' element={
        <PrivateRoute>
          <WhatsAppMessageLog />
        </PrivateRoute>
      } />

      <Route path='/inventory/v1.2/whatsapp/timeline/:userId' element={
        <PrivateRoute>
          <WhatsAppUserTimeline />
        </PrivateRoute>
      } />

      <Route path='/inventory/v1.2/whatsapp/offers' element={
        <PrivateRoute>
          <WhatsAppOffers />
        </PrivateRoute>
      } />

      <Route path='/inventory/v1.2/whatsapp/support' element={
        <PrivateRoute>
          <WhatsAppSupportQueue />
        </PrivateRoute>
      } />

      <Route path='/inventory/v1.2/whatsapp/staff-alerts' element={
        <PrivateRoute>
          <WhatsAppStaffAlerts />
        </PrivateRoute>
      } />

      <Route path='/inventory/v1.2/whatsapp/test-flows' element={
        <PrivateRoute>
          <WhatsAppTestFlows />
        </PrivateRoute>
      } />

      {/* Catch all route */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AllRoutes;